'use strict';

module.exports = function (stream) {
  var ended;

  if (typeof stream.ended !== 'undefined') {
    ended = stream.ended;
  } else {
    ended = stream._readableState.ended;
  }

  return Boolean(ended).valueOf();
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-stream-ended/index.js
// module id = 1Ur7
// module chunks = 0